const wa10memberValidator = (memberId: string) => {
  if (!memberId) {
    return true;
  }

  const checkMemberId = /^[0-9]{10}$/;
  if (!checkMemberId.test(memberId)) {
    return false;
  }

  return true;
};

export default wa10memberValidator;
